import { createAction, props } from '@ngrx/store';
import { DownloadListItem } from './download-list.models';

export const addToDownloadList = createAction(
  '[DownloadList] Set Download List',
  props<{ document: DownloadListItem }>()
);

export const removeFromDownloadList = createAction(
  '[DownloadList] Remove From Download List',
  props<{
    documentId: number;
    start_page?: number;
    end_page?: number;
    assetId?: string;
  }>()
);

export const downloadList = createAction(
  '[DownloadList] Download List',
  props<{ documents: DownloadListItem[]; fileName: string; downloadMode: string }>()
);

export const downloadListSuccess = createAction('[DownloadList] Download List Success', props<{ message: string }>());

export const downloadListFailure = createAction(
  '[DownloadList] Download List Failure',
  props<{ error: { status: number; message: string } }>()
);

export const clearDownloadList = createAction('[DownloadList] Clear Download List');

export const cancelDownload = createAction('[DownloadList] Cancel Download');

export const updateDownloadList = createAction(
  '[DownloadList] Update Download List',
  props<{ documents: DownloadListItem[] }>()
);

export const addPageToDownloadListClicked = createAction(
  '[DetailPage Catalog] Add page to download list',
  props<{
    pageType: 'left' | 'right' | 'both' | null;
    documentId: number;
    categoryId: number;
    docuLanguage: string;
  }>()
);

export const syncDownloadListFromStorage = createAction(
  '[DownloadList] Sync From Storage',
  props<{ documents: DownloadListItem[] }>()
);
